import { MutationTree } from 'vuex';
import { State } from './state';
import {
    SET_SYSTEM_LIST,
    SET_REGISTER_FORM_VISIBILITY,
    SET_SELECTED_SYSTEM,
    ADD_SYSTEM_TO_LIST,
} from './types';
import { ISystem } from '../models';


export const mutations: MutationTree<State> = {
    [SET_SYSTEM_LIST](state: State, payload: ISystem[]) {
        state.systems = payload;
    },
    [SET_REGISTER_FORM_VISIBILITY](state: State, payload: boolean) {
        state.showRegisterForm = payload;
    },
    [SET_SELECTED_SYSTEM](state: State, payload: ISystem) {
        state.systemSelected = payload;
    },
    [ADD_SYSTEM_TO_LIST](state: State, payload: ISystem) {
        state.systems.push(payload);
    },
};
